import React from "react";

/**
 * Componente che mostra un indicatore di caricamento
 * @param {Object} props - Proprietà del componente
 * @param {string} props.size - Dimensione dello spinner ('sm', 'md', 'lg')
 * @param {string} props.color - Colore dello spinner (default: blue)
 * @returns {JSX.Element}
 */
const Spinner = ({ size = "md", color = "blue" }) => {
  // Determina le classi CSS in base alla dimensione
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-8 h-8",
    lg: "w-12 h-12"
  };
  
  // Determina le classi CSS in base al colore
  const colorClasses = {
    blue: "text-blue-500",
    gray: "text-gray-500",
    green: "text-green-500",
    red: "text-red-500"
  };
  
  const sizeClass = sizeClasses[size] || sizeClasses.md;
  const colorClass = colorClasses[color] || colorClasses.blue;
  
  return (
    <div className="flex justify-center items-center">
      <div className={`animate-spin rounded-full border-2 border-t-transparent ${sizeClass} ${colorClass}`}></div>
    </div>
  );
};

export default Spinner;
